import React, { useCallback, useState } from "react";
import SelectBox from "../../../components/SelectBox";
import useAppContext from "../../../utils/Reducers";

const SearchBar = (props) => {
  // SerachBar 기본 필드

  const {
    store: { userInfo },
  } = useAppContext();

  const [initFields, setInitFields] = useState({
    schGroupNm: "",
  });

  const handleChangeField = useCallback((event) => {
    const { name, value } = event.target;

    setInitFields({ ...initFields, [name]: value });
    props.setSearchParameters({ ...initFields, [name]: value });
  });

  return (
    <>
      <div className="searchdata">
        <ul>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 그룹명
            </div>
            <input
              type="text"
              className="datainput"
              name="schGroupNm"
              onChange={handleChangeField}
              value={initFields.schGroupNm}
            />
          </li>
        </ul>
      </div>
    </>
  );
};

export default React.memo(SearchBar);
